<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b>{{title}}</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <!-- Form -->
  <form *ngIf="party" role="form" name="addEditForm" #addEditForm="ngForm" novalidate>
    <div *ngIf="showSelectResourceMessage" class="alert alert-warning" role="alert">
      <span>Please select a {{user.resourceSettings?.label || 'resource' }} to track it on the served page.</span>
    </div>
    <div class="row">
      <!-- Phone -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-phone" class="control-label">Phone<br></label>
        <div class="d-flex">
          <input
            id="input-modal-phone"
            type="tel"
            pattern="[\-+\(\)\s\d]*"
            name="phone"
            data-dd-privacy="mask"
            appPhonePatternCountryValidator="phone"
            [phoneCountry]="user?.country"
            #partyPhone="ngModel"
            [(ngModel)]="party.phone"
            [ngClass]="{'is-invalid': partyPhone.touched && partyPhone.invalid }"
            (ngModelChange)="partyPhoneLookup(); changeMessagingProvider();"
            [value]="party.phone | trTel: user.country"
            class="form-control"
            trTrimSpaces
            [class.mr-2]="isWhatsAppEnabled()"
          >
          <tablesready-whatsapp-toggle
            *ngIf="isWhatsAppEnabled()"
            name="messagingProvider"
            [(ngModel)]="party.messagingProvider"
            [disabled]="!party.phone || isUsOrCaPhoneNumber() || party.source === partySources.api"
            ngbTooltip="Send via WhatsApp"
          ></tablesready-whatsapp-toggle>
        </div>
        <control-messages [control]="partyPhone"></control-messages>

      </div>
      <!-- Name -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-name" class="control-label">Name</label>
        <input id="input-modal-name"
               type="text"
               #partyName="ngModel"
               [(ngModel)]="party.name"
               name="name"
               data-dd-privacy="mask"
               noWhitespace
               [ngClass]="skipName ? null : {'is-invalid': partyName.touched && partyName.invalid }"
               class="form-control"
               required
               trTrimSpaces
        />
        <control-messages *ngIf="!skipName" [control]="partyName"></control-messages>
      </div>
    </div>

    <div class="row" *ngIf="customer">
      <div class="col-12 form-group">
        <tablesready-party-customer-info
          [customer]="customer"
          [timezone]="timezone"
        ></tablesready-party-customer-info>
      </div>
    </div>

    <div class="row" *ngIf="user.waitFields.size">
      <!-- Size -->
      <div class="col-12 form-group">
        <label for="input-modal-size" class="control-label">Size</label>
        <div class="btn-group d-flex flex-wrap" id="input-modal-size">

          <common-radio-group
            name="size"
            [items]="sizesRadioItems"
            [(ngModel)]="party.size"
            [indentation]="true"
            (ngModelChange)="selectResources()"
            uncheckedButtonClass="btn-info-outline btn-tel"
            checkedButtonClass="btn-info-outline btn-tel"
          ></common-radio-group>

          <input name="sizeOther"
                 type="number"
                 #partySizeOther="ngModel"
                 [(ngModel)]="sizeOther"
                 (change)="changeSize(); selectResources()"
                 style="width:4rem;"
                 placeholder="8+"
                 pattern="\d*"
                 min="0"
                 [min]="0"
                 (focus)="party.size>=8"
                 [ngClass]="{'is-invalid': partySizeOther.touched && partySizeOther.invalid }"
                 class="form-control btn-tel"/>
          <control-messages [control]="partySizeOther"></control-messages>
        </div>
      </div>
    </div>
    <!-- Date -->
    <div class="row" *ngIf="isReservation">
      <div class="col-xs-12 col-sm-6 form-group">
        <label for="reservation-date-input" class="control-label">Date</label>
        <input
          id="reservation-date-input"
          class="form-control"
          type="text"
          ngbDatepicker
          container="body"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [weekdays]="true"
          [firstDayOfWeek]="7"
          #datepicker="ngbDatepicker"
          name="date"
          [(ngModel)]="party.date"
          (ngModelChange)="changeDate()"
          #partyDate="ngModel"
          [disabled]="selectedTimeMode"
          [ngClass]="{'is-invalid': partyDate.touched && partyDate.invalid}"
          (click)="datepicker.toggle()"
          [restoreFocus]="true"
          autocomplete="off"
          required
        />
        <div *ngIf="!party.date">
          <div class="error-messages">This field is required</div>
        </div>
      </div>
      <!-- Time -->
      <div class="col-xs-12 col-sm-6 form-group">
        <label class="control-label">Time</label>
        <tr-timepicker-input
          name="time"
          [(ngModel)]="party.time"
          (ngModelChange)="changeDate()"
          [disabled]="selectedTimeMode"
          #partyTime="ngModel"
          [ngClass]="{'is-invalid': (partyTime.dirty || partyTime.touched) && !party.time }"
          required>
        </tr-timepicker-input>
        <control-messages [control]="partyTime"></control-messages>
      </div>
    </div>
    <!-- quoted -->
    <div class="row">
      <div *ngIf="isWalkin && (!user.waitFields || user.waitFields.quoted_time)"
           class="col-xs-12 col-sm-6 form-group">
        <label for="input-modal-time"
               class="control-label">{{user.displayOptions?.labels?.quoted || 'quoted time' | titlecase}}</label>
        <div data-toggle="buttons" class="with-five-buttons d-flex justify-content-between">
          <input id="input-modal-time"
                 class="form-control"
                 type="number"
                 [(ngModel)]="party.quoted_time_minutes"
                 name="quoted_time_minutes"
                 required
                 #quotedTime
                 pattern="[-\d]*"
                 [ngClass]="{'is-invalid':quotedTime.touched && quotedTime.invalid }"
                 (blur)="setQuotedTime()"/>
          <button type="button" class="btn btn-info" (click)="changeQuoted(5)"
                  id="plus-5-button">+5
          </button>
          <button type="button" class="btn btn-info" (click)="changeQuoted(-5)"
                  id="minus-5-button">-5
          </button>
        </div>
      </div>
      <!-- Notes -->
      <div class="col-xs-12 form-group"
           [ngClass]="(!user.waitFields || user.waitFields.quoted_time) ? 'col-sm-6' : 'col-sm-12'">
        <ng-container *ngIf="noteOptions?.length > 0; else plainNoteInput">
          <frontend-dropdown-clear [dropdown]="notesDropdown">
            <label for="input-modal-note" class="control-label">Notes</label>
          </frontend-dropdown-clear>
          <frontend-dropdown
            #notesDropdown
            elementId="input-modal-note"
            [items]="noteOptions"
            [multiple]="true"
            clearAllText="Clear"
            name="note"
            [addTag]="true"
            [(ngModel)]="party.note"
            placeholder="Select notes"
            [clearable]="true"
            [plainValues]="true"
            [inlineClearButton]="false"
          ></frontend-dropdown>
        </ng-container>
        <ng-template #plainNoteInput>
          <label for="input-modal-note" class="control-label">Notes</label>
          <input type="text"
                 id="input-modal-note"
                 class="form-control"
                 name="note-input"
                 [(ngModel)]="party.note"
                 trTrimSpaces
          />
        </ng-template>
      </div>
      <!-- services -->
      <div *ngIf="servicesInDropdown?.length" class="col-xs-12 col-sm-6 form-group">
        <frontend-dropdown-clear [dropdown]="servicesDropdown">
          <label class="control-label">
            {{serviceSettingsLabel}}
            <span *ngIf="shortenedDurationState?.hasShortenedDuration" class="text-warning ml-1">⚠️</span>
          </label>
        </frontend-dropdown-clear>
        <frontend-dropdown
          #servicesDropdown
          elementId="input-modal-service"
          [items]="servicesInDropdown"
          [multiple]="true"
          bindLabel="name"
          bindValue="_id"
          clearAllText="Clear"
          name="services"
          [(ngModel)]="party.services"
          (ngModelChange)="selectServices()"
          [clearable]="true"
          [inlineClearButton]="false"
          [customOptionHtml]="getServiceOptionName"
        ></frontend-dropdown>
      </div>
      <!-- duration -->
      <div *ngIf="servicesInDropdown?.length && party?.services?.length && party?.duration"
           class="col-xs-12 col-sm-6 form-group">
        <label
          for="input-modal-services-duration"
          class="control-label"
        >{{serviceSettingsLabel}} duration</label>
        <div data-toggle="buttons" class="with-five-buttons d-flex justify-content-between">
          <input class="form-control"
                 type="number"
                 name="quoted_time"
                 #partyDurationInMinutes
                 [(ngModel)]="party.durationInMinutes"
                 id="input-modal-services-duration"
                 pattern="[-\d]*"
                 min="0"
                 required
                 [ngClass]="{'is-invalid': partyDurationInMinutes.touched && partyDurationInMinutes.invalid }"
                 (change)="changeDuration()"/>
          <button type="button" class="btn btn-info"
                  (click)="changeQuoted(5, 'durationInMinutes', 'duration')">+5
          </button>
          <button type="button" class="btn btn-info"
                  (click)="changeQuoted(-5, 'durationInMinutes', 'duration')">-5
          </button>
        </div>
      </div>
      <!-- resources -->
      <div *ngIf="resourcesInDropdown?.length"
           class="col-xs-12 col-sm-6 form-group">
        <frontend-dropdown-clear [dropdown]="resourcesDropdown">
          <label class="control-label">{{resourceSettingsLabel}}</label>
        </frontend-dropdown-clear>
        <frontend-dropdown
          #resourcesDropdown
          elementId="input-modal-resource"
          [items]="resourcesInDropdown"
          [multiple]="true"
          clearAllText="Clear"
          name="resources"
          [(ngModel)]="party.resources"
          (ngModelChange)="this.selectResources()"
          [customName]="getItemName"
          [customOptionHtml]="getItemOptionName"
          [clearable]="true"
          [inlineClearButton]="false"
          [markFirstSuggested]="user?.resourceSettings.resourceSuggestion === resourceSuggestionOption.suggestion"
        ></frontend-dropdown>
      </div>
    </div>

    <ng-container *ngIf="availableOnBusinessPlan">
      <tablesready-party-custom-fields
        id="customFields"
        name="customFields"
        [config]="user.partyFields"
        [(ngModel)]="party.customFields"
        [country]="user.country"
      ></tablesready-party-custom-fields>
    </ng-container>


    <div *ngIf="isAvailableTime"
         class="alert alert-warning d-flex justify-content-between"
         role="alert">
      Sorry, we don't have an available {{resourceSettingsLabel}} at
      this time.
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideNoResources"
               [(ngModel)]="overrideNoResources"
               (change)="overrideResources()">
      </label>
    </div>
    <div *ngIf="checkIfOutOfBusinessHours(addEditForm)"
         class="alert alert-warning" role="alert">
      {{ getOutOfBusinessHoursMessage() }}
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideIsWorkTime"
               [(ngModel)]="overrideIsWorkTime">
      </label>
    </div>
    <div *ngIf="showBlockedTimeWarning()"
         class="alert alert-warning d-flex justify-content-between"
         role="alert">
      This time is blocked for new {{ displayOptionsReservationsLabelPlural }}.
      <label class="form-check-label pl-0 d-flex">
        <strong>Override?</strong>
        <input type="checkbox"
               class="ml-2"
               name="overrideBlockedTime"
               [(ngModel)]="overrideBlockedTime">
      </label>
    </div>
    <div *ngIf="noAvailableServices(addEditForm)"
         class="alert alert-warning"
         role="alert">
      Sorry, no services available at this time.
    </div>
    <div *ngIf="resourceSizeAlert" class="alert alert-warning" role="alert">
      {{ resourceSizeAlert }}
    </div>
    <div *ngIf="showOverlappingAlert && !overrideNoResources" class="alert alert-warning" role="alert">
      Sorry, this {{displayOptionsReservationsLabel}} overlaps
      with another.
      Available duration is {{availablePartyDurationInMin}} min
      <div class="link" (click)="setAvailableDuration()">Set duration to available time?</div>
    </div>
    <!-- Shortened duration warning -->
    <tablesready-shortened-duration-warning
      *ngIf="!isSubmitting"
      [state]="shortenedDurationState"
      [(confirmed)]="shortenedDurationConfirmed"
    ></tablesready-shortened-duration-warning>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button *ngIf="party?.checkin_time && !party?.seated_time"
          type="button"
          class="btn btn-success mr-auto"
          (click)="undoCheckIn()"
          angularticsCategory="reservations"
          angulartics2On="click"
          angularticsAction="undo reservation check-in"
          [disabled]="isSubmitting"
  >Undo Check-In</button>
  <button *ngIf="party?.checkin_time && party?.seated_time"
          type="button"
          class="btn btn-success mr-auto"
          (click)="undoServed()"
          angularticsCategory="parties"
          angulartics2On="click"
          angularticsAction="undo party serve"
          [disabled]="isSubmitting"
  >Undo Served</button>
  <button
    type="submit"
    class="btn btn-info"
    (click)="ok()"
    angularticsCategory="reservations"
    angulartics2On="click"
    id="confirm-add-edit-party-button"
    [disabled]="isSubmitDisabled(addEditForm)"
    angularticsAction="{{angularticsActionType}}"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
  >Cancel</button>
</div>

<ng-template #confirmModalContent let-confirmModal>
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title">
      There is already a {{displayOptionCustomerLabel}} on your waitlist with this phone number. Are you sure you want to proceed?
    </h3>
    <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="confirmModal.close('Cancel click')"></tr-icon>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-info"
            (click)="confirmModal.close('Confirm click')">Confirm
    </button>
    <button type="button" class="btn btn-danger"
            (click)="confirmModal.close('Cancel click')">Cancel
    </button>
  </div>
</ng-template>
